"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useDeviceType = require("./useDeviceType");
Object.keys(_useDeviceType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDeviceType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDeviceType[key];
    }
  });
});
var _useShoppingBag = require("./useShoppingBag");
Object.keys(_useShoppingBag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useShoppingBag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useShoppingBag[key];
    }
  });
});